import { Component, ViewChild } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { NgScrollbar } from 'ngx-scrollbar';

import { IconDirective } from '@coreui/icons-angular';
import {
  ButtonDirective,
  ContainerComponent,
  ShadowOnScrollDirective,
  SidebarBrandComponent,
  SidebarComponent,
  SidebarFooterComponent,
  SidebarHeaderComponent,
  SidebarNavComponent,
  SidebarToggleDirective,
  SidebarTogglerDirective,
  ToasterComponent,
  ToasterPlacement,
} from '@coreui/angular-pro';

import { DefaultAsideComponent, DefaultFooterComponent, DefaultHeaderComponent } from './';
import { navItems } from './_nav';
import { AppToastComponent } from 'src/app/views/notifications/toasters/toast-simple/toast.component';
import { BaseService } from '../../base.service';
import { environment } from '../../../environments/environment';
import { TestingToolkitComponent } from '../../components/testing-toolkit/testing-toolkit.component';

function isOverflown(element: HTMLElement) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}
interface MenuItem {
  Id: number;
  ParentMenuID: number;
  MenuItemName: string;
  URL: string;
  IconPath: string;
  IsActive: boolean;
}

export interface MenuStructure {
  name: string;
  url: string;
  iconComponent: { name: string };
  children: MenuStructure[];
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  standalone: true,
  imports: [
    SidebarComponent,
    SidebarHeaderComponent,
    SidebarBrandComponent,
    RouterLink,
    IconDirective,
    ToasterComponent,
    NgScrollbar,
    SidebarNavComponent,
    SidebarFooterComponent,
    SidebarToggleDirective,
    SidebarTogglerDirective,
    DefaultAsideComponent,
    DefaultHeaderComponent,
    ShadowOnScrollDirective,
    ContainerComponent,
    RouterOutlet,
    DefaultFooterComponent,
    ButtonDirective,
    TestingToolkitComponent,
  ]
})
export class DefaultLayoutComponent {
  public navItems = navItems;
  placement = ToasterPlacement.TopCenter;
  @ViewChild(ToasterComponent) toaster!: ToasterComponent;

  // Show testing toolkit only in non-production environments
  isProduction = environment.production;

  rootMenuItems: MenuStructure[] = [];
  menuMap: { [key: number]: MenuStructure } = {};
  public menuList: any;

  public perfectScrollbarConfig = {
    suppressScrollX: true,
  };

  constructor(private BaseService: BaseService,
    private router: Router,
  ) { }


  ngOnInit(): void {
    // check if user is not logged in return to login page
    if (!localStorage.getItem('token')) {
      this.router.navigate(['/login']);
    }

    let menuListString = localStorage.getItem('menuData') as string;

    // Parse the string into an array of objects
    this.menuList = JSON.parse(menuListString);

    // Now, you can work with this.menuList as an array of objects
    console.log(this.menuList);

    this.menuList.forEach((menuItem: any) => {
      const { id, parent_Id, menuName, url, iconPath, isActive } = menuItem;
      if (isActive) {
        this.menuMap[id] = { name: menuName, url: url, iconComponent: { name: iconPath }, children: [] };
        if (parent_Id === 0) {
          this.rootMenuItems.push(this.menuMap[id]);
        } else {
          // if (this.menuMap[parent_Id]) {
          //   this.menuMap[parent_Id].children.push(this.menuMap[id]);
          // }
        }

      }
    });

    console.log("🚀 > DefaultLayoutComponent > this.menuList.forEach > this.rootMenuItems:", this.rootMenuItems)
    // Then, assign child menu items to their parent
    // this.menuList.forEach((menuItem: any) => {
    //   const { Id, ParentMenuID } = menuItem;
    //   if (ParentMenuID !== 0) {
    //     this.menuMap[ParentMenuID].children.push(this.menuMap[Id]);
    //   }
    // });


  }

  onScrollbarUpdate($event: any) {
    // if ($event.verticalUsed) {
    // console.log('verticalUsed', $event.verticalUsed);
    // }
  }
}
